import React from 'react';
import styled from 'styled-components';

import { Skeleton } from 'components';

import { Container } from './common';
import Row from './Row';

const StyledContainer = styled(Container)`
  padding: 0 2rem 0 2rem;
`;

export default (
  <StyledContainer>
    <Skeleton title={false} paragraph={{ rows: 1, width: '20%' }} />
    <Row
      label={
        <Skeleton
          title={false}
          paragraph={{
            style: {
              display: 'flex',
              flexWrap: 'wrap',
              marginTop: 18,
            },
            rows: 4,
            width: ['90%', '90%', '90%', '90%'],
          }}
        />
      }
    >
      <Skeleton
        title={false}
        paragraph={{
          style: {
            display: 'flex',
            flexWrap: 'wrap',
            marginTop: 18,
            alignItems: 'space-between',
          },
          rows: 4,
          width: ['90%', '90%', '90%', '90%'],
        }}
      />
    </Row>
  </StyledContainer>
);
